import React from 'react';
import styles from './text-field.module.scss';

interface Props {
    text: string;
}

export function TextField({
    text
}: Props) {
    return (
        <div className={styles.text}>
            {text}
        </div>
    );
}